
import WhatWeOffer from "../../components/WhatWeOffer/WhatWeOffer";
import OurApproach from "../../components/OurApproach/OurApproach";
import ServicesHighlight from "../../components/ServicesHighlight/ServicesHighlight";
import "./Services.css";

function Services() {
  return (
    <div>
      <WhatWeOffer />
      <ServicesHighlight />
      <OurApproach />
    </div>
  );
}

export default Services;
